import { useState, type FormEvent } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '@/stores/authStore';
import { Panel } from '@/components/ui/Panel';
import { Button } from '@/components/ui/Button';
import { BrandLogos } from '@/components/layout/BrandLogos';

export function Login() {
  const { session, signIn, loading, error } = useAuthStore();
  const location = useLocation() as { state?: { from?: { pathname: string } } };
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);

  if (session) return <Navigate to={location.state?.from?.pathname ?? '/'} replace />;

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    setBusy(true);
    try {
      await signIn(email.trim(), password);
    } catch {
      /* the store holds the message */
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="login">
      <div className="login__card">
        <BrandLogos />

        <Panel>
          <form onSubmit={onSubmit}>
            {error && <div className="login__error">{error}</div>}

            <div className="login__field">
              <label className="login__label" htmlFor="email">Email</label>
              <input
                id="email"
                type="email"
                autoComplete="username"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                autoFocus
              />
            </div>

            <div className="login__field">
              <label className="login__label" htmlFor="password">Password</label>
              <input
                id="password"
                type="password"
                autoComplete="current-password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>

            <Button type="submit" block size="lg" loading={busy || loading}>
              Sign in
            </Button>
          </form>
        </Panel>

        <p className="muted small" style={{ textAlign: 'center', marginTop: 'var(--sp-4)' }}>
          Accounts are created by the administrator. Contact them
          if you cannot sign in.
        </p>
      </div>
    </div>
  );
}
